import React from 'react'

function Note() {
  return (
    <div className='bg-primary-900 text-center p-5 text-white text-xl text-shadow-[0_60px_60px_rgb(0_0_0_/_1)]
'>
        Edupro Hub gives you the power to prepare students better—by replicating the exact exam experience, before the real thing.
    </div>
  )
}

export default Note